'use strict';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import Alert from '../../Alert';

import ProgressStepIndicator from '../ProgressStepIndicator';
import Loader from '../../Loader';
import OTButton from '../../tag/OTButton';
import OTButtonGroup from '../../tag/OTButtonGroup';
import WindowUtils from '../../../utils/WindowUtils';

const { id: module_id } = module;

class AgreementPage4 extends React.Component {
  constructor() {
    super();
    this.state = { agreement: '', error: null };
  }

  componentDidMount() {
    document.getElementById('skip-to-content').focus();
  }

  agree = (val) => {
    this.setState({ agreement: val });
  };

  showError = (event) => {
    event.preventDefault();
    this.setState({ error: true });
  };

  cancel = (event) => {
    event.preventDefault();
    this.props.triggerCancelModal();
  };

  next = (event) => {
    if (this.state.agreement === 'deny') {
      this.cancel(event);
    } else if (this.state.agreement === 'agree') {
      WindowUtils.navigate('#/5');
    } else {
      this.showError(event);
    }
  };

  render() {
    let { userInfo } = this.props;

    if (!userInfo) {
      return <Loader />;
    }

    return (
      <div className="ot-agreement-page">
        <h1 className="ot-agreement-title">
          <FormattedMessage id={`${module_id}.title`} />
        </h1>
        <ProgressStepIndicator total={3} current={2} />
        <p className="infoTitle">
          <b>
            <FormattedMessage id={`${module_id}.infotitle`} />
          </b>
        </p>
        <div className="row-fluid infotext">
          <div className="span6">
            <p>
              <b>
                <FormattedMessage id={`${module_id}.infotext2`} />
              </b>
            </p>
            <p>
              <FormattedMessage id={`${module_id}.infotext3`} />
            </p>
          </div>
          {/* Fields are not editable in any case, so we are not making these into fields*/}
          <div className="span6 ot-agreement-form">
            <div className="control-group">
              <div className="controls">
                <fieldset>
                  <span className="radio-block">
                    <label htmlFor={'agree'}>
                      <input
                        type="radio"
                        name="agree"
                        value="agree"
                        id="agree"
                        checked={this.state.agreement === 'agree'}
                        onChange={() => this.agree('agree')}
                      />
                      <span className="radio-check" />
                      <span className="radio-label">
                        <FormattedMessage id={`${module_id}.radioagree`} />
                      </span>
                    </label>
                  </span>
                  <span className="radio-block">
                    <label htmlFor={'deny'}>
                      <input
                        type="radio"
                        name="deny"
                        value="deny"
                        id="deny"
                        checked={this.state.agreement === 'deny'}
                        onChange={() => this.agree('deny')}
                      />
                      <span className="radio-check" />
                      <span className="radio-label">
                        <FormattedMessage id={`${module_id}.radiodecline`} />
                      </span>
                    </label>
                  </span>
                </fieldset>
              </div>
              <div>
                {this.state.error && (
                  <Alert message="agreement.selection.error" />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="ot-agreement-buttons row-fluid text-center">
          <OTButtonGroup fullWidth type={'big'} expectedCount={2}>
            <OTButton onClick={this.cancel}>
              <FormattedMessage id={'abort'} />
            </OTButton>
            <OTButton onClick={this.next}>
              <FormattedMessage id={'continue'} />
            </OTButton>
          </OTButtonGroup>
        </div>
      </div>
    );
  }
}

export default AgreementPage4;
